import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useEffect } from "react";
import { LayoutDashboard, Package, ShoppingCart, Users, Settings, LogOut, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/admin", icon: LayoutDashboard, label: "Painel", end: true },
  { to: "/admin/produtos", icon: Package, label: "Produtos" },
  { to: "/admin/pedidos", icon: ShoppingCart, label: "Pedidos" },
  { to: "/admin/clientes", icon: Users, label: "Clientes" },
  { to: "/admin/configuracoes", icon: Settings, label: "Configurações" },
];

export default function AdminLayout({ children }) {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!loading && (!user || user.role !== "admin")) nav("/admin/entrar");
  }, [user, loading, nav]);

  if (loading || !user || user.role !== "admin") return <div className="p-10 text-center">Verificando acesso...</div>;

  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col lg:flex-row">
      <aside className="lg:w-64 bg-white border-r lg:min-h-screen">
        <div className="p-5 border-b flex items-center justify-between">
          <div className="flex flex-col leading-none">
            <span className="font-extrabold text-lg text-[#C91F1F]" style={{ fontFamily: "Outfit" }}>NALIN</span>
            <span className="text-[9px] tracking-widest text-[#D4A928] font-bold">ADMIN</span>
          </div>
        </div>
        <nav className="p-3 space-y-1">
          {NAV.map(({ to, icon: Icon, label, end }) => (
            <NavLink key={to} to={to} end={end} className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium ${isActive ? "bg-[#C91F1F] text-white" : "hover:bg-neutral-100 text-neutral-700"}`}>
              <Icon className="h-4 w-4" />{label}
            </NavLink>
          ))}
          <div className="border-t my-3" />
          <a href="/" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium hover:bg-neutral-100 text-neutral-700"><Home className="h-4 w-4" />Ver loja</a>
          <button onClick={() => { logout(); nav("/"); }} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium hover:bg-neutral-100 text-neutral-700"><LogOut className="h-4 w-4" />Sair</button>
        </nav>
      </aside>
      <main className="flex-1 p-4 sm:p-8">{children}</main>
    </div>
  );
}
